var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('CaseReportHeader',{attrs:{"caseReport":_vm.caseReport,"backButton":true}})],1),_c('CaseReportBody',{attrs:{"caseReport":_vm.caseReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }